<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.uid'
              v-show="showUid"
              label='uid'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="学员"
              v-model="insertData.fromUid"
              :options="computedUsers"
              :disabled="disableUser"
              searchable
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="被评论导师"
              v-model="insertData.toUid"
              :options="computedMentors"
              :disabled="disableMentor"
              searchable
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.comment"
              type="textarea"
              label="评论内容"
              removable
              :messages="message"
              :error="!!error.commentErrors.length"
              :error-messages="error.commentErrors"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '../../utils/common'
import consultingApi from '../../api/consulting'
import userApi from '../../api/user'
import mentorApi from '../../api/mentor'
import commentApi from '@/api/comment'

export default {
  data () {
    return {
      insertData: {
        id: null,
        uid: null,
        commentId: null,
        toUid: '',
        fromUid: '',
        comment: '',
      },
      message: ['Required field'],
      mentors: [],
      users: [],
      error: {
        toUidErrors: [],
        fromUidErrors: [],
        commentErrors: [],
      },
      showId: false,
      showUid: false,
      showCreateTime: false,
      disableMentor: false,
      disableUser: false,
      title: '新增评论',
      submitButtonStatus: true,
      userOptions: [],
      mentorOptions: [],
    }
  },
  created () {
    this.listMentor()
    this.listUser()
  },
  computed: {
    formReady () {
      return !this.error.toUidErrors.length &&
          !this.error.fromUidErrors.length &&
          !this.error.commentErrors.length
    },
    computedMentors () {
      return this.mentors.map(x => {
        return `${x.nickname}(${x.uid})`
      })
    },
    computedUsers () {
      return this.users.map(x => {
        return `${x.nickname}(${x.uid})`
      })
    },
    flipMentors () {
      const flipMentors = {}
      this.mentors.forEach(x => {
        flipMentors[`${x.nickname}(${x.uid})`] = x.uid
      })
      return flipMentors
    },
    flipUsers () {
      const flipUsers = {}
      this.users.forEach(x => {
        flipUsers[`${x.nickname}(${x.uid})`] = x.uid
      })
      return flipUsers
    },
  },
  methods: {
    listMentor () {
      this.mentorOptions = []
      const params = {
        pageNumber: 1,
        pageSize: 1000,
      }
      mentorApi.listMentor(params).then(response => {
        this.mentors = response.mentors
        response.mentors.forEach(x => {
          this.mentorOptions.push(x.nickname + '(' + x.uid + ')')
        })
      }).catch(error => {
        console.log(error)
      })
    },
    listUser () {
      this.userOptions = []
      const params = {
        pageNumber: 1,
        pageSize: 10000,
        userType: 4,
      }
      userApi.listUser(params).then(response => {
        this.users = response.users
        response.users.forEach(x => {
          this.userOptions.push(x.nickname + '(' + x.uid + ')')
        })
      }).catch(error => {
        console.log(error)
      })
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        fromUid: this.insertData.fromUid,
        toUid: this.insertData.toUid,
        comment: this.insertData.comment,
      }
      if (this.insertData.uid != null) {
        data.uid = this.insertData.uid
        data.commentId = this.insertData.commentId
        commentApi.updateComment(data.commentId, data).then(response => {
          if (response.success === true) {
            this.showToast('更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listComment' })
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
          this.changeButtonStatus(true)
        })
      } else {
        data.toUid = this.flipMentors[this.insertData.toUid]
        data.fromUid = this.flipUsers[this.insertData.fromUid]
        commentApi.saveComment(data).then(response => {
          if (response.success === true) {
            this.showToast('保存成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listComment' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.fromUidErrors = this.insertData.fromUid ? [] : ['user is required']
      this.error.toUidErrors = this.insertData.toUid ? [] : ['mentor is required']
      this.error.commentErrors = this.insertData.comment ? [] : ['comment is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
